import { ModalTemplateWrapper } from '#app/components/Modals/V2/GlobalModalSystem/ModalTemplateWrapper/ModalTemplateWrapper.js';
import { SocialUSDCSolidIcon } from '@contra/icons/icons';

type CryptoDisclaimerModalV2Props = {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onSubmit: () => void;
};

export const CryptoDisclaimerModalV2 = ({
  isOpen,
  onClose,
  onSubmit,
}: CryptoDisclaimerModalV2Props) => {
  return (
    <ModalTemplateWrapper
      ariaLabel="Crypto Disclaimer"
      ctaOptions={{
        primaryCTA: {
          handleOnClick: onSubmit,
          label: 'Continue',
          variant: 'V2Primary',
        },
      }}
      desktopModalSize="md"
      headerText="Adding a USDC wallet"
      icon={<SocialUSDCSolidIcon />}
      isDismissible
      isOpen={isOpen}
      onClose={onClose}
      subheaderText="We recommend using the USDC wallet address that’s directly linked to
      your crypto exchange such as Coinbase, Binance, Newton, and more. This
      will help avoid fees from third-party crypto wallets like MetaMask,
      Exodus, and others."
    />
  );
};
